import { useGetDetailedPaymentPrefQuery } from "#graphql/supergraphHooks";
import { type DetailedPaymentPrefUnionObjectType } from "../common/types";
import { useConsolidatedPaymentPrefContext } from "../Context";

/*
 * This hook returns the detailed payment preference data stored in the context if it exists,
 * otherwise it fetches the detailed payment preference data from the server with the payment
 * preference ID stored in the context.
 */
export const useGetDetailedPaymentPref = () => {
  const { paymentPrefId, paymentPrefDetail } = useConsolidatedPaymentPrefContext();

  const { data, loading, error } = useGetDetailedPaymentPrefQuery({
    variables: {
      id: paymentPrefId!,
    },
    skip: !paymentPrefId || !!paymentPrefDetail,
    fetchPolicy: "network-only",
  });

  let detailedPaymentPref: DetailedPaymentPrefUnionObjectType | null = null;
  if (paymentPrefDetail) {
    detailedPaymentPref = paymentPrefDetail;
  } else if (data?.paymentPrefs && data?.paymentPrefs.length > 0) {
    detailedPaymentPref = data?.paymentPrefs[0].paymentPrefFull;
  }

  return { data: detailedPaymentPref, loading, error };
};
